import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RaportyGodzinoweDaneResponse } from 'src/app/modele/administracja/raportyGodzinoweDane';
import { RaportyGodzinoweFiltryModel } from 'src/app/modele/administracja/raportyGodzinoweFiltry';
import { PobierzProjektyFiltr } from 'src/app/modele/projekty/pobierzProjektyFiltr';
import { PobierzUzytkownikowFiltr } from 'src/app/modele/uzytkownik/pobierzUzytkownikowFiltr';
import { ComboBox } from 'src/app/modele/wspolne/comboBox';
import { ModalOpcje } from 'src/app/modele/wspolne/modal-opcje.ogolne';
import { RejestrFiltrowanyRequest } from 'src/app/modele/wspolne/rejestrFiltrowanyRequest';
import { Routing } from 'src/app/modele/wspolne/routing';
import { Stronicowanie } from 'src/app/modele/wspolne/stronicowanie';
import { RaportyService } from 'src/app/serwisy/administracja/raporty.service';
import { UzytkownikService } from 'src/app/serwisy/konto/uzytkownik.service';
import { AuthService } from 'src/app/serwisy/ogolne/auth.service';
import { LoaderService } from 'src/app/serwisy/ogolne/loader.service';
import { ProjektyService } from 'src/app/serwisy/projekty/projekty.service';
import { BazowyComponent } from '../../bazowy.component';
import { TakNieModalComponent } from '../../ogolne/tak-nie-modal/tak-nie-modal.component';
import { ZakresDatWynik } from '../../wspolne/zakres-dat/zakres-dat.component';
import { DodajGodzinyModalComponent } from './dodaj-godziny-modal/dodaj-godziny-modal.component';
import {
  KierunekSortowania,
  Sortowanie,
} from 'src/app/modele/wspolne/sortowanie';

export interface GodzinyDnia {
  data: string;
  dataFormatowana: string;
  godziny: number | null;
}

export interface RaportGodzinowy {
  id: string;
  pracownikId: string;
  imieNazwisko: string;
  email: string;
  projektId: string;
  projektNazwa: string;
  domyslneGodziny: number;
  godzinyDni: GodzinyDnia[];
}

interface PendingHourChange {
  pracownikId: string;
  projektId: string;
  data: string;
  godziny: number | null;
}

@Component({
  selector: 'app-raporty-godzinowe-edycja',
  templateUrl: './raporty-godzinowe-edycja.component.html',
  styleUrls: ['./raporty-godzinowe-edycja.component.css'],
})
export class RaportyGodzinoweEdycjaComponent
  extends BazowyComponent
  implements OnInit
{
  czyZaladowanoDane: boolean = false;
  czyPokazanoPodmenu: boolean = false;

  // Sortowanie
  kierunekSortowania: { pracownik: string; suma: string; projekt: string } = {
    pracownik: '',
    suma: '',
    projekt: '',
  };
  raportyWyswietlane: RaportGodzinowy[] = [];

  // Paginacja
  rozmiarTabeli: number = 25;
  strona: number = 1;
  calkowitaLiczbaElementow: number = 0;
  czyJestWiecejRekordow: boolean = false;

  // Filtry
  wybraneProjektyId: string[] = [];
  wybraniPracownicyId: string[] = [];
  statusProjektu: string;
  statusPracownika: string;
  dataOd: string = '';
  dataDo: string = '';
  czyPokazacWszystkichPracownikow: boolean = false;

  projekty: { id: string; nazwa: string }[] = [];
  pracownicy: { id: string; nazwa: string }[] = [];
  statusyProjektow = [
    { id: 'wszystkie', nazwa: 'Wszystkie' },
    { id: 'aktywne', nazwa: 'Aktywne' },
    { id: 'archiwalne', nazwa: 'Archiwalne' },
  ];
  statusyPracownikow = [
    { id: 'wszyscy', nazwa: 'Wszyscy' },
    { id: 'aktywni', nazwa: 'Aktywni' },
    { id: 'archiwalni', nazwa: 'Archiwalni' },
  ];

  slideConfig = {
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: document.getElementsByClassName('btn__left'),
    nextArrow: document.getElementsByClassName('btn__right'),
    infinite: false,
    variableWidth: true,
    initialSlide: 2,
  };

  // Lista dat (kolumny)
  daty: { data: string; dataFormatowana: string }[] = [];

  // Lista pracowników z ich godzinami
  raporty: RaportGodzinowy[] = [];

  // Batch editing - niezapisane zmiany godzin dziennych
  pendingChanges: Map<string, PendingHourChange> = new Map();

  constructor(
    public router: Router,
    modalService: NgbModal,
    loaderSerwis: LoaderService,
    komunikatSerwis: ToastrService,
    public authService: AuthService,
    public translateSerwis: TranslateService,
    private raportySerwis: RaportyService,
    private activatedRoute: ActivatedRoute,
    private uzytkownikSerwis: UzytkownikService,
    private projektySerwis: ProjektyService
  ) {
    super(
      authService,
      modalService,
      loaderSerwis,
      komunikatSerwis,
      router,
      translateSerwis
    );
  }

  ngOnInit(): void {
    setTimeout(() => {
      if (!this.czyAdmin()) {
        this.router.navigate([Routing.StronaGlowna]);
        return;
      }
      this.pobierzFiltryZUrl();
      this.zaladujDaneStartowe();
    });
  }

  private zaladujDaneStartowe(): void {
    forkJoin({
      pracownicy: this.pobierzPracownikow(),
      projekty: this.pobierzProjekty(),
    }).subscribe({
      next: (dane) => {
        this.pracownicy = dane.pracownicy;
        this.projekty = dane.projekty;
        this.pobierzDaneDoEkranu();
      },
      error: () => {
        this.wyswietlKomunikat('Błąd podczas ładowania danych', true);
      },
    });
  }

  pobierzDaneDoEkranu() {
    const model = new RejestrFiltrowanyRequest<RaportyGodzinoweFiltryModel>();
    model.filtry = {
      dataOd: this.dataOd,
      dataDo: this.dataDo,
      pracownicyIds:
        this.wybraniPracownicyId.length > 0 ? this.wybraniPracownicyId : null,
      projektyIds:
        this.wybraneProjektyId.length > 0 ? this.wybraneProjektyId : null,
      statusPracownika: this.mapujStatusPracownika(this.statusPracownika),
      statusProjektu: this.mapujStatusProjektu(this.statusProjektu),
      czyPokazacWszystkichPracownikow: this.czyPokazacWszystkichPracownikow,
    };
    model.stronicowanie = new Stronicowanie(false);
    model.stronicowanie.iloscRekordow = this.rozmiarTabeli;
    model.stronicowanie.strona = this.strona;
    model.sortowanie = this.budujSortowanie();

    this.raportySerwis
      .pobierzDaneDoEdycjiRaportowGodzinowych(model)
      .subscribe((rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.przetworzOdpowiedzApi(rezultat.element);
          this.czyZaladowanoDane = true;
        }
      });
  }

  private mapujStatusPracownika(status: string): string {
    switch (status) {
      case 'aktywni':
        return 'aktywny';
      case 'archiwalni':
        return 'archiwalny';
      case 'wszyscy':
      default:
        return 'wszystko';
    }
  }

  private mapujStatusProjektu(status: string): string {
    switch (status) {
      case 'aktywne':
        return 'aktywny';
      case 'archiwalne':
        return 'archiwalny';
      case 'wszystkie':
      default:
        return 'wszystko';
    }
  }

  private budujSortowanie(): Sortowanie {
    if (this.kierunekSortowania.pracownik === 'up') {
      return new Sortowanie('imieNazwisko', KierunekSortowania.asc);
    } else if (this.kierunekSortowania.pracownik === 'down') {
      return new Sortowanie('imieNazwisko', KierunekSortowania.desc);
    } else if (this.kierunekSortowania.projekt === 'up') {
      return new Sortowanie('projektNazwa', KierunekSortowania.asc);
    } else if (this.kierunekSortowania.projekt === 'down') {
      return new Sortowanie('projektNazwa', KierunekSortowania.desc);
    } else if (this.kierunekSortowania.suma === 'up') {
      return new Sortowanie('sumaWiersza', KierunekSortowania.asc);
    } else if (this.kierunekSortowania.suma === 'down') {
      return new Sortowanie('sumaWiersza', KierunekSortowania.desc);
    }
    return new Sortowanie('imieNazwisko', KierunekSortowania.asc);
  }

  private przetworzOdpowiedzApi(dane: RaportyGodzinoweDaneResponse): void {
    // Przetwórz daty
    this.daty = dane.daty.map((data) => {
      const dataObj = new Date(data);
      const dzien = dataObj.getDate().toString().padStart(2, '0');
      const miesiac = (dataObj.getMonth() + 1).toString().padStart(2, '0');
      return {
        data: data,
        dataFormatowana: `${dzien}.${miesiac}`,
      };
    });

    // Przetwórz wiersze na format komponentu
    this.raporty = dane.wiersze.map((wiersz) => ({
      id: wiersz.id,
      pracownikId: wiersz.pracownikId,
      imieNazwisko: wiersz.imieNazwisko,
      email: wiersz.email || '',
      projektId: wiersz.projektId || '',
      projektNazwa: wiersz.projektNazwa || '',
      domyslneGodziny: wiersz.domyslneGodziny,
      godzinyDni: wiersz.godzinyDni.map((godzinyDnia) => {
        const dataObj = new Date(godzinyDnia.data);
        const dzien = dataObj.getDate().toString().padStart(2, '0');
        const miesiac = (dataObj.getMonth() + 1).toString().padStart(2, '0');
        return {
          data: godzinyDnia.data,
          dataFormatowana: `${dzien}.${miesiac}`,
          godziny: godzinyDnia.godziny,
        };
      }),
    }));

    // Aktualizuj paginację z odpowiedzi API
    this.calkowitaLiczbaElementow = dane.liczbaWszystkich;
    this.strona = dane.strona;
    this.czyJestWiecejRekordow =
      dane.strona * dane.rozmiarStrony < dane.liczbaWszystkich;

    // Dane są już posortowane i stronicowane z API, więc bezpośrednio przypisujemy
    this.raportyWyswietlane = this.raporty;
  }

  // Oblicz sumę godzin dla pracownika
  obliczSumePracownika(raport: RaportGodzinowy): number {
    return raport.godzinyDni.reduce(
      (suma, dzien) => suma + (dzien.godziny || 0),
      0
    );
  }

  // Oblicz sumę godzin dla konkretnego dnia (wszystkich pracowników)
  obliczSumeDnia(data: string): number {
    return this.raporty.reduce((suma, raport) => {
      const dzien = raport.godzinyDni.find((d) => d.data === data);
      return suma + (dzien?.godziny || 0);
    }, 0);
  }

  // Oblicz sumę wszystkich godzin
  obliczSumeCalkowita(): number {
    return this.raporty.reduce(
      (suma, raport) => suma + this.obliczSumePracownika(raport),
      0
    );
  }

  // Walidacja wartości godzin
  private walidujGodziny(value: number | null): {
    valid: boolean;
    message?: string;
  } {
    if (value === null) return { valid: true };
    if (isNaN(value))
      return { valid: false, message: 'Wartość musi być liczbą' };
    if (value < 0)
      return { valid: false, message: 'Liczba godzin nie może być ujemna' };
    if (value > 24)
      return { valid: false, message: 'Liczba godzin nie może przekraczać 24' };
    return { valid: true };
  }

  // Aktualizuj domyślne godziny pracownika
  aktualizujDomyslneGodziny(raport: RaportGodzinowy, event: Event) {
    const input = event.target as HTMLInputElement;
    const value = parseFloat(input.value);

    // Walidacja
    const walidacja = this.walidujGodziny(value);
    if (!walidacja.valid) {
      this.wyswietlKomunikat(walidacja.message, true);
      input.value = raport.domyslneGodziny?.toString() || '0';
      return;
    }

    if (!isNaN(value) && raport.projektId) {
      this.raportySerwis
        .edytujDomyslnaLiczbeGodzinPracy({
          pracownikId: raport.pracownikId,
          projektId: raport.projektId,
          liczbaGodzin: value,
        })
        .subscribe({
          next: (response) => {
            if (this.czyRezultatOk(response)) {
              raport.domyslneGodziny = value;
              this.wyswietlKomunikat('Zapisano domyślne godziny');
            }
          },
          error: () => this.wyswietlKomunikat('Błąd zapisu', true),
        });
    }
  }

  // Aktualizuj godziny dla konkretnego dnia
  aktualizujGodzinyDnia(raport: RaportGodzinowy, data: string, event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value === '' ? null : parseFloat(input.value);

    // Walidacja
    const walidacja = this.walidujGodziny(value);
    if (!walidacja.valid) {
      this.wyswietlKomunikat(walidacja.message, true);
      const obecneGodziny = this.pobierzGodzinyDnia(raport, data);
      input.value = obecneGodziny?.toString() || '';
      return;
    }

    if (raport.projektId) {
      this.raportySerwis
        .edytujGodzinyPracyDnia({
          pracownikId: raport.pracownikId,
          projektId: raport.projektId,
          liczbaGodzin: value, // pozwól na null - API potraktuje jako 0
          data: data,
        })
        .subscribe({
          next: (response) => {
            if (this.czyRezultatOk(response)) {
              let dzien = raport.godzinyDni.find((d) => d.data === data);
              if (dzien) {
                dzien.godziny = value;
              } else {
                // Dodaj nowy wpis jeśli nie istnieje
                const dataObj = new Date(data);
                const dzienNum = dataObj.getDate().toString().padStart(2, '0');
                const miesiac = (dataObj.getMonth() + 1)
                  .toString()
                  .padStart(2, '0');
                raport.godzinyDni.push({
                  data: data,
                  dataFormatowana: `${dzienNum}.${miesiac}`,
                  godziny: value,
                });
              }
              this.wyswietlKomunikat('Zapisano godziny');
            }
          },
          error: () => this.wyswietlKomunikat('Błąd zapisu', true),
        });
    }
  }

  // Potwierdź usunięcie dnia
  potwierdzUsuwanieDnia(data: string) {
    const dzien = this.daty.find((d) => d.data === data);
    this.modalReference = this.modalService.open(
      TakNieModalComponent,
      new ModalOpcje(true, 'static')
    );
    this.modalReference.componentInstance.naglowek = 'Potwierdzenie usunięcia';
    this.modalReference.componentInstance.pytanie = `Czy na pewno chcesz usunąć wszystkie godziny z dnia ${dzien?.dataFormatowana}?`;

    this.modalReference.result.then(
      (result) => {
        if (result) {
          this.usunDzien(data);
        }
      },
      () => {}
    );
  }

  // Usuń cały dzień (kolumnę) - wywołanie API
  usunDzien(data: string) {
    this.raportySerwis.usunGodzinyPracyDnia({
      data,
      pracownicyIds: this.wybraniPracownicyId.length > 0 ? this.wybraniPracownicyId : undefined,
      projektyIds: this.wybraneProjektyId.length > 0 ? this.wybraneProjektyId : undefined
    }).subscribe({
      next: (response) => {
        if (this.czyRezultatOk(response)) {
          this.pobierzDaneDoEkranu();
          this.wyswietlKomunikat('Usunięto godziny dnia');
        }
      },
      error: () => this.wyswietlKomunikat('Błąd usuwania', true),
    });
  }

  // Dodaj nowy dzień
  dodajDzien() {
    // Znajdź ostatnią datę i dodaj kolejny dzień
    if (this.daty.length > 0) {
      const ostatniaData = new Date(this.daty[this.daty.length - 1].data);
      ostatniaData.setDate(ostatniaData.getDate() + 1);

      const nowaData = ostatniaData.toISOString().split('T')[0];
      const dzien = ostatniaData.getDate().toString().padStart(2, '0');
      const miesiac = (ostatniaData.getMonth() + 1).toString().padStart(2, '0');

      this.daty.push({
        data: nowaData,
        dataFormatowana: `${dzien}.${miesiac}`,
      });

      // Dodaj nowy dzień do wszystkich raportów
      this.raporty.forEach((raport) => {
        raport.godzinyDni.push({
          data: nowaData,
          dataFormatowana: `${dzien}.${miesiac}`,
          godziny: raport.domyslneGodziny,
        });
      });
    }
  }

  // Pobierz godziny dla konkretnego pracownika i dnia
  pobierzGodzinyDnia(raport: RaportGodzinowy, data: string): number | null {
    const dzien = raport.godzinyDni.find((d) => d.data === data);
    return dzien ? dzien.godziny : null;
  }

  // Batch editing - metody pomocnicze
  private generujKluczKomorki(
    pracownikId: string,
    projektId: string,
    data: string
  ): string {
    return `${pracownikId}_${projektId}_${data}`;
  }

  czyMaNiezapisaneZmiany(
    pracownikId: string,
    projektId: string,
    data: string
  ): boolean {
    return this.pendingChanges.has(
      this.generujKluczKomorki(pracownikId, projektId, data)
    );
  }

  naZmianeGodzinDnia(
    raport: RaportGodzinowy,
    data: string,
    event: Event
  ): void {
    const input = event.target as HTMLInputElement;
    const value = input.value === '' ? null : parseFloat(input.value);

    const walidacja = this.walidujGodziny(value);
    if (!walidacja.valid) return;

    const klucz = this.generujKluczKomorki(
      raport.pracownikId,
      raport.projektId,
      data
    );
    const obecnaWartosc = this.pobierzGodzinyDnia(raport, data);

    if (value === obecnaWartosc) {
      this.pendingChanges.delete(klucz);
    } else {
      this.pendingChanges.set(klucz, {
        pracownikId: raport.pracownikId,
        projektId: raport.projektId,
        data: data,
        godziny: value,
      });
    }
  }

  zapiszWszystkieZmianyGodzin(): void {
    if (this.pendingChanges.size === 0) return;

    const zmianyDoZapisu = Array.from(this.pendingChanges.values()).map(
      (zmiana) => ({
        pracownikId: zmiana.pracownikId,
        projektId: zmiana.projektId,
        liczbaGodzin: zmiana.godziny ?? 0,
        data: zmiana.data,
      })
    );

    this.raportySerwis.edytujGodzinyPracyDniaBatch(zmianyDoZapisu).subscribe({
      next: (response) => {
        if (this.czyRezultatOk(response)) {
          // Aktualizuj dane w modelu dla wszystkich zmian
          zmianyDoZapisu.forEach((zmiana) => {
            const raport = this.raporty.find(
              (r) =>
                r.pracownikId === zmiana.pracownikId &&
                r.projektId === zmiana.projektId
            );
            if (raport) {
              let dzien = raport.godzinyDni.find((d) => d.data === zmiana.data);
              if (dzien) {
                dzien.godziny = zmiana.liczbaGodzin;
              } else {
                const dataObj = new Date(zmiana.data);
                const dzienNum = dataObj.getDate().toString().padStart(2, '0');
                const miesiac = (dataObj.getMonth() + 1)
                  .toString()
                  .padStart(2, '0');
                raport.godzinyDni.push({
                  data: zmiana.data,
                  dataFormatowana: `${dzienNum}.${miesiac}`,
                  godziny: zmiana.liczbaGodzin,
                });
              }
            }
          });
          this.pendingChanges.clear();
          this.wyswietlKomunikat(
            `Zapisano godziny pracy (${zmianyDoZapisu.length})`
          );
        } else {
          this.wyswietlKomunikat('Błąd zapisu godzin', true);
        }
      },
      error: () => {
        this.wyswietlKomunikat('Błąd zapisu godzin', true);
      },
    });
  }

  aktualizujGodzinyDniaZEnter(
    raport: RaportGodzinowy,
    data: string,
    event: Event
  ): void {
    // NIE wywołuj naZmianeGodzinDnia - zmiany są już w pendingChanges z (input)
    this.zapiszWszystkieZmianyGodzin();
  }

  // Pokazywanie podmenu na mobile
  pokazPodmenu() {
    this.czyPokazanoPodmenu = !this.czyPokazanoPodmenu;
  }

  filtrujISortuj() {
    this.raportyWyswietlane = [...this.raporty];
  }

  zmienSortowanie(kolumna: 'pracownik' | 'suma' | 'projekt') {
    // Reset innych kolumn
    const kolumny: ('pracownik' | 'suma' | 'projekt')[] = [
      'pracownik',
      'suma',
      'projekt',
    ];
    kolumny
      .filter((k) => k !== kolumna)
      .forEach((k) => (this.kierunekSortowania[k] = ''));

    // Cykl: '' -> 'up' -> 'down' -> ''
    const obecny = this.kierunekSortowania[kolumna];
    if (obecny === '') this.kierunekSortowania[kolumna] = 'up';
    else if (obecny === 'up') this.kierunekSortowania[kolumna] = 'down';
    else this.kierunekSortowania[kolumna] = '';

    this.strona = 1;
    this.pobierzDaneDoEkranu();
  }

  // Paginacja
  zmienRozmiarTabeli(): void {
    this.strona = 1;
    this.pobierzDaneDoEkranu();
  }

  zmienStrone(oIle: number): void {
    this.strona += oIle;
    this.pobierzDaneDoEkranu();
  }

  pobierzNumerRekorduPoczatek(): number {
    return (this.strona - 1) * this.rozmiarTabeli + 1;
  }

  pobierzNumerRekorduKoniec(): number {
    const koniec = this.strona * this.rozmiarTabeli;
    return Math.min(koniec, this.calkowitaLiczbaElementow);
  }

  // Filtry URL
  pobierzFiltryZUrl(): void {
    const params = this.activatedRoute.snapshot.queryParamMap;
    const projektyParam = params.get('projekty');
    this.wybraneProjektyId = projektyParam ? projektyParam.split(',') : [];
    const pracownicyParam = params.get('pracownicy');
    this.wybraniPracownicyId = pracownicyParam
      ? pracownicyParam.split(',')
      : [];
    this.statusProjektu = params.get('statusProjektu');
    this.statusPracownika = params.get('statusPracownika');
    this.czyPokazacWszystkichPracownikow =
      params.get('wszyscyPracownicy') === 'true';

    const domyslnyZakres = this.obliczAktualnyMiesiac();
    this.dataOd = params.get('dataOd') || domyslnyZakres.od;
    this.dataDo = params.get('dataDo') || domyslnyZakres.do;
  }

  zapiszFiltryWUrl(): void {
    this.router.navigate([], {
      queryParams: this.budujQueryParams(),
      queryParamsHandling: '',
      replaceUrl: true,
      relativeTo: this.activatedRoute,
    });
  }

  budujQueryParams(): object {
    return {
      projekty:
        this.wybraneProjektyId.length > 0
          ? this.wybraneProjektyId.join(',')
          : null,
      pracownicy:
        this.wybraniPracownicyId.length > 0
          ? this.wybraniPracownicyId.join(',')
          : null,
      statusProjektu: this.statusProjektu || 'aktywne',
      statusPracownika: this.statusPracownika || 'aktywni',
      wszyscyPracownicy: this.czyPokazacWszystkichPracownikow ? 'true' : null,
      dataOd: this.dataOd,
      dataDo: this.dataDo,
    };
  }

  obliczAktualnyMiesiac(): { od: string; do: string } {
    const dzis = new Date();
    const pierwszyDzien = new Date(dzis.getFullYear(), dzis.getMonth(), 1);
    const ostatniDzien = new Date(dzis.getFullYear(), dzis.getMonth() + 1, 0);

    return {
      od: this.formatujDate(pierwszyDzien),
      do: this.formatujDate(ostatniDzien),
    };
  }

  private formatujDate(data: Date): string {
    const rok = data.getFullYear();
    const miesiac = (data.getMonth() + 1).toString().padStart(2, '0');
    const dzien = data.getDate().toString().padStart(2, '0');
    return `${rok}-${miesiac}-${dzien}`;
  }

  private pobierzPracownikow(): Observable<ComboBox[]> {
    return this.raportySerwis.pobierzUzytkownikow(false).pipe(
      map((r) =>
        r.listaElementow.map((u) => ({
          id: u.id,
          nazwa: `${u.imie} ${u.nazwisko} (${u.email})`,
        }))
      )
    );
  }

  private pobierzProjekty(): Observable<ComboBox[]> {
    const model = new RejestrFiltrowanyRequest<PobierzProjektyFiltr>();
    model.stronicowanie = new Stronicowanie(true);
    model.sortowanie = new Sortowanie('nazwaProjektu', KierunekSortowania.asc);
    model.filtry = new PobierzProjektyFiltr();

    return this.raportySerwis.PobierzProjekty(model, false).pipe(
      map((r) =>
        r.listaElementow.map((p) => ({
          id: p.id,
          nazwa: `${p.nazwaProjektu} (${this.formatujDateMiesiac(p.dataUtworzenia)})`,
        }))
      )
    );
  }

  private formatujDateMiesiac(data: string | Date): string {
    const d = new Date(data);
    const rok = d.getFullYear();
    const miesiac = (d.getMonth() + 1).toString().padStart(2, '0');
    return `${rok}-${miesiac}`;
  }

  zastosujFiltry(): void {
    this.zapiszFiltryWUrl();
    this.strona = 1;
    this.pobierzDaneDoEkranu();
  }

  zaznaczWszystkieProjekty(): void {
    this.wybraneProjektyId = this.projekty.map((p) => p.id);
    this.zastosujFiltry();
  }

  odznaczWszystkieProjekty(): void {
    this.wybraneProjektyId = [];
    this.zastosujFiltry();
  }

  zaznaczWszystkichPracownikow(): void {
    this.wybraniPracownicyId = this.pracownicy.map((p) => p.id);
    this.zastosujFiltry();
  }

  odznaczWszystkichPracownikow(): void {
    this.wybraniPracownicyId = [];
    this.zastosujFiltry();
  }

  naZakresZmieniony(zakres: ZakresDatWynik): void {
    this.dataOd = zakres.dataOd;
    this.dataDo = zakres.dataDo;
    this.zastosujFiltry();
  }

  przelaczPokazWszystkichPracownikow(): void {
    this.czyPokazacWszystkichPracownikow =
      !this.czyPokazacWszystkichPracownikow;
    this.zastosujFiltry();
  }

  otworzModalDodajGodziny(): void {
    this.modalReference = this.modalService.open(
      DodajGodzinyModalComponent,
      new ModalOpcje(true, 'static')
    );

    // Przekazanie list do modala
    this.modalReference.componentInstance.pracownicy = this.pracownicy;
    this.modalReference.componentInstance.projekty = this.projekty;
    this.modalReference.componentInstance.istniejaceWpisy = this.raporty;

    this.modalReference.result.then(
      (result) => {
        if (result) {
          this.dodajGodzinyPracy(result);
        }
      },
      (onRejected) => {}
    );
  }

  dodajGodzinyPracy(
    dane: {
      pracownikId: string;
      projektId: string;
      data: string;
      godziny: number;
    },
    potwierdzonoNadpisanie = false
  ): void {
    this.raportySerwis
      .dodajGodzinyPracy({
        pracownikId: dane.pracownikId,
        projektId: dane.projektId,
        liczbaGodzin: dane.godziny,
        data: dane.data,
        potwierdzonoNadpisanie: potwierdzonoNadpisanie,
      })
      .subscribe({
        next: (response) => {
          if (this.czyRezultatOk(response)) {
            if (
              response.element?.czySaJuzGodzinyTegoDnia &&
              !potwierdzonoNadpisanie
            ) {
              this.pokazModalPotwierdzeniaNadpisania(dane);
            } else {
              this.pobierzDaneDoEkranu();
              this.wyswietlKomunikat('Dodano godziny pracy');
            }
          }
        },
        error: () => this.wyswietlKomunikat('Błąd dodawania godzin', true),
      });
  }

  pokazModalPotwierdzeniaNadpisania(dane: {
    pracownikId: string;
    projektId: string;
    data: string;
    godziny: number;
  }): void {
    this.modalReference = this.modalService.open(
      TakNieModalComponent,
      new ModalOpcje(true, 'static')
    );
    this.modalReference.componentInstance.pytanie =
      'Godziny dla tego dnia już istnieją. Czy nadpisać?';
    this.modalReference.result.then(
      (result) => {
        if (result) {
          this.dodajGodzinyPracy(dane, true);
        }
      },
      () => {}
    );
  }

  nawigujDoPodgladuRaportow(): void {
    this.router.navigate(['/admin/reports'], {
      queryParams: this.budujQueryParams(),
    });
  }

  czyPokazacWyczyscFiltry(): boolean {
    const domyslnyZakres = this.obliczAktualnyMiesiac();
    return (
      this.wybraneProjektyId.length > 0 ||
      this.wybraniPracownicyId.length > 0 ||
      (this.statusProjektu && this.statusProjektu !== 'aktywne') ||
      (this.statusPracownika && this.statusPracownika !== 'aktywni') ||
      this.czyPokazacWszystkichPracownikow ||
      this.dataOd !== domyslnyZakres.od ||
      this.dataDo !== domyslnyZakres.do
    );
  }

  wyczyscFiltry(): void {
    this.wybraneProjektyId = [];
    this.wybraniPracownicyId = [];
    this.statusProjektu = null;
    this.statusPracownika = null;
    this.czyPokazacWszystkichPracownikow = false;

    const domyslnyZakres = this.obliczAktualnyMiesiac();
    this.dataOd = domyslnyZakres.od;
    this.dataDo = domyslnyZakres.do;

    this.zastosujFiltry();
  }
}
